import { combineEpics } from 'redux-observable';

import { recordConsentEpic } from './record-consent.epic';
import { recordOfferConsentEpic } from './record-offer-consent.epic';

const legalConsentEpic = combineEpics(recordConsentEpic, recordOfferConsentEpic);

export { legalConsentEpic };
